export default {
  spanish_list(state) {
    return state.spanish_list;
  },
};
